var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen.and.line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1822 3.18356C13.1513 3.1534 13.1197 3.12248 13.0878 3.09061C13.0559 3.05873 13.025 3.02709 12.9949 2.99623C12.7172 2.71213 12.505 2.49502 12.2211 2.7789L11.5029 3.49705L11.0315 3.96842L4.69516 10.3048L4.45941 10.5405L3.62701 12.3281C3.55957 12.4675 3.71089 12.6189 3.85037 12.5514L5.63786 11.7189L13.3995 3.95732C13.6834 3.67347 13.4663 3.46124 13.1822 3.18356ZM5.63786 11.7189L4.45941 10.5405L4.69516 10.3048L5.87356 11.4832L5.63786 11.7189ZM11.0315 3.96842L12.2099 5.14687L12.6813 4.67546L11.5029 3.49705L11.0315 3.96842Z",
    fill: "#006241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 13C3.39036 13 3.1665 13.2238 3.1665 13.5C3.1665 13.7761 3.39036 14 3.6665 14H13.3332C13.6093 14 13.8332 13.7761 13.8332 13.5C13.8332 13.2238 13.6093 13 13.3332 13H3.6665Z",
    fill: "#006241"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPending);
export default __webpack_public_path__ + "static/media/editPending.f4cfec5813982441c8f20766167e546d.svg";
export { ForwardRef as ReactComponent };